import { FormGroup } from '@angular/forms';
import { ListType } from '../../../../../../shared';

const MAX_FOLIO_LIST_LENGTH = 50000;
const MAX_GRIDICS_ID_LIST_LENGTH = 10000;
const MAX_GROUP_ID_LIST_LENGTH = 45000;

export class CalculateFolioSubFormValidator {
    static validateFolioList(listForm: FormGroup) {

        const typeControl = listForm.get('type');
        const listControl = listForm.get('list');
        const layers = listForm.get('layers');
        const list = listControl.value.split('\n').filter(e => e);

        const areThereErrors = (typeControl.value === ListType.FOLIOS && list.length > MAX_FOLIO_LIST_LENGTH) ||
            (typeControl.value === ListType.GRIDICS_IDS && list.length > MAX_GRIDICS_ID_LIST_LENGTH) ||
            (typeControl.value === ListType.GROUP_IDS && list.length > MAX_GROUP_ID_LIST_LENGTH);

        const areTheLayersErrors = (
            !layers.get('city').value &&
            !layers.get('county').value &&
            !layers.get('state').value
        );

        if (areThereErrors) {
            listControl.setErrors({ 'maxItems': true });
        } else if (areTheLayersErrors) {
            listControl.setErrors({ 'noSelection': true });
        } else if (listControl) {
            listControl.setErrors(null);
        }

        return null;
    }
}
